<template>
  <div class="step-progress">
    <div class="step-progress__container">
      <ul class="step-progress__steps">
        <li
          class="step-progress__step"
          :class="[
            i <= active && 'step-progress__step--active',
            i === active && 'step-progress__step--current',
          ]"
          v-for="(step, i) in steps"
          :key="i"
        >
          {{ step }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stepProgress',
  props: {
    steps: {
      type: Array,
      required: true,
    },
    active: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isCurrent(index) {
      return index === this.active
    },
  },
}
</script>

<style lang="scss" scoped>
.step-progress {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 5px;
  &__steps {
    counter-reset: step;
    width: 525px;
  }
  &__step {
    float: left;
    width: 33%;
    position: relative;
    text-align: center;
    color: #888888;
    list-style-type: none;
    font-size: rem(20px);
    font-weight: 700;
    line-height: 26px;
    &:before {
      content: ' ';
      width: 19px;
      height: 19px;
      border: 5px solid #343436;
      display: block;
      margin: 0 auto 10px auto;
      border-radius: 50%;
      line-height: 27px;
      background: var(--tundora-gray);
      text-align: center;
      font-weight: bold;
    }
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      top: 9px;
      left: -50%;
      z-index: -1;
      border: 1px solid var(--tundora-gray);
    }
    &--active {
      &:before {
        border: 5px solid #57a28c;
        background: #65fccf;
      }
      &:after {
        background: linear-gradient(145.56deg, #65fccf 20.53%, #70ffd4 79.76%);
        border-radius: 0px;
        height: 5px;
        top: 7px;
        z-index: 1;
        border-width: 0px;
      }
    }
    &--current {
      color: #ffffff;
    }
    &:first-child:after {
      content: none;
    }
  }
}
</style>
